import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ConfirmationDialogState {
  isOpen: boolean;
  message: string;
  title?: string;
  resolve: ((value: boolean) => void) | null;
}

const initialState: ConfirmationDialogState = {
  isOpen: false,
  message: "",
  title: undefined,
  resolve: null,
};

const confirmationDialogSlice = createSlice({
  name: "confirmationDialog",
  initialState,
  reducers: {
    showConfirmationDialog: (
      state,
      action: PayloadAction<{
        message: string;
        title?: string;
        resolve: (value: boolean) => void;
      }>
    ) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.resolve = action.payload.resolve;
    },
    confirmDialog: (state) => {
      const resolve = state.resolve;
      state.isOpen = false;
      state.message = "";
      state.title = undefined;
      state.resolve = null;
      // Defer callback execution to avoid Redux state access during reducer execution
      if (resolve) {
        setTimeout(() => resolve(true), 0);
      }
    },
    cancelDialog: (state) => {
      const resolve = state.resolve;
      state.isOpen = false;
      state.message = "";
      state.title = undefined;
      state.resolve = null;
      // Defer callback execution to avoid Redux state access during reducer execution
      if (resolve) {
        setTimeout(() => resolve(false), 0);
      }
    },
  },
});

export const {
  showConfirmationDialog,
  confirmDialog,
  cancelDialog,
} = confirmationDialogSlice.actions;

export default confirmationDialogSlice.reducer;
